import * as Yup from 'yup';

export const fields = [
    {
        name: 'merchant_login',
        label: 'Логин магазина',
        type: 'text',
        placeholder: 'Введите логин',
        position: 10,
    },
    {
        name: 'first_password',
        label: 'Пароль #1',
        type: 'password',
        placeholder: 'Введите пароль',
        position: 20,
    },
    {
        name: 'second_password',
        label: 'Пароль #2',
        type: 'password',
        placeholder: 'Введите пароль',
        position: 30,
    },
];

export const validationSchema = Yup.object({
    code: Yup.string().max(50),
});

export const initialValues = {
    metatag: '',
    project_id: null,
    secretKey: null,
};
